export const NEWS_REQUESTED = 'NEWS_REQUESTED'
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS'
export const GET_NEWS_FAILURE = 'GET_NEWS_FAILURE'
export const SET_FILTERED_REQUESTED = 'SET_FILTERED_REQUESTED'
export const SET_FILTERED_DATA = 'SET_FILTERED_DATA'
export const SET_FILTERED_FAILURE = 'SET_FILTERED_FAILURE'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'
export const SET_NEWS_MODAL_STATE = 'SET_NEWS_MODAL_STATE'
export const REMOVE_NEWS_MODAL_STATE = 'REMOVE_NEWS_MODAL_STATE'
export const GET_PAGE_DATA_SUCCESS = 'GET_PAGE_DATA_SUCCESS'
export const GET_PAGE_DATA_FAILURE = 'GET_PAGE_DATA_FAILURE'
export const GET_PAGE_DATA_INITIAL = 'GET_PAGE_DATA_INITIAL'
